import { ILabelPrintScenarioViewDTO } from "../../../../libs/coreapi-dto/dirs/labelPrintScenario";

export interface IInitialState {
    items: ILabelPrintScenarioViewDTO[]
}

type Action = { type: 'setItems', payload: ILabelPrintScenarioViewDTO[] }//

export const initialState: IInitialState = {
    items: []
};

export function reducer(state: IInitialState = initialState, action: Action): IInitialState {
    switch (action.type) {
        case 'setItems':
            return { ...state, items: action.payload }
        default:
            throw new Error();
    }
}